import { Separator } from '@radix-ui/react-context-menu';
import { styled } from 'styled-components';

const ContextMenuSeparator = styled(Separator).withConfig({
  displayName: "ContextMenuSeparator",
  componentId: "sc-9be20d37-0"
})([
  `height:1px;background:rgba(255,255,255,0.1);margin:2px 0;`
]);

export { ContextMenuSeparator };
//# sourceMappingURL=ContextMenuSeparator.js.map
